import {signInExistingAccountStyles} from "@insite/content-library/Widgets/SignIn/SignInExistingAccount"
import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm"
import { BaseTheme } from "@insite/mobius/globals/baseTheme"
import { breakpointMediaQueries } from "@insite/mobius/utilities"
import { css } from "styled-components"

signInExistingAccountStyles.signInButton = {
    mergeCss: true,
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
}

signInResetPasswordFormStyles.cancelButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
}